import { Injectable } from '@angular/core';
import {
  ToastController,
  LoadingController,
  AlertController,
  ModalController, 
} from '@ionic/angular';

import { EncryptorService } from '../encryptor/encryptor.service';

@Injectable({
  providedIn: 'root',
})
export class CommonService {
  public langData: any;
  public internet = { status: '', message: '' };
  public pageData = { modal: undefined };
  public loader: any = false;
  public default_url: string =
    'https://images.meebuddy.com/products/no_image.jpg';

  constructor(
    public loadingCtrl: LoadingController,
    public toastCtrl: ToastController,
    public storage: EncryptorService,
    // public network: Network,
    public alertCtrl: AlertController,
    public modalCtrl: ModalController
  ) {
    this.loadLanguage();
  }

  loadLanguage() {
    this.langData = this.storage.getObject('langData');
  }

  async toastMsg(msg) {
    let toast =await this.toastCtrl.create({
      message: msg,
      duration: 3000,
    });
    toast.present();
  }

  async presentLoading(msg) {
    let loading =await this.loadingCtrl.create({message:msg});
    loading.present();

    setTimeout(() => {
      loading.dismiss();
    }, 1000);
  }

  async startLoader() {
    this.loader = await this.loadingCtrl.create({
      message: 'Please wait...',
    });
      // .then(() => {
    this.loader.present();
    //   });
    setTimeout(() => {
      this.stopLoader();
    }, 5000);
  }
  
  stopLoader() {
    if (this.loader) this.loader.dismiss();
    this.loader = false;
  }

  closeLoader() {
    if (this.loader) this.toastMsg('Network Problem');
    this.stopLoader();
  }

  imgError(event) {
    event.srcElement.src = this.default_url;
  }

  camelCase(str) {
    if (!str) return '';
    return str
      .trim()
      .split(' ')
      .filter((x) => x)
      .map((a) => a[0].toUpperCase() + a.substring(1).toLowerCase())
      .join(' ');
  }

  networkOn() {
    this.internet.status = 'on';
    this.internet.message = 'We are back !...';
    setTimeout(() => {
      this.internet.status = '';
      this.internet.message = '';
    }, 900);
  }

  networkOff() {
    this.internet.status = 'off';
    this.internet.message = 'Network disconnected';
  }

  stringAsDate(dateStr: string) {

    let now = new Date().getTime();
  
    let past = new Date(dateStr).getTime();
  
    let time = now - past;
  
    let diffDay = Math.floor(time / 86400000);
  
    let diffHour = Math.floor((time % 86400000) / 3600000);
  
    let diffMinute = Math.floor(((time % 86400000) % 3600000) / 60000);
  
    let diffSecs = Math.floor((((time % 86400000) % 3600000) % 60000) / 1000 ); 
  
    let diffMonths = Math.floor(diffDay/30);
  
    let diffyears = Math.floor(diffMonths/12);
  
    if (diffSecs >= 1 && diffMinute < 1){
  
      return diffSecs + " seconds ago";
  
    }else if(diffMinute >= 1 && diffHour < 1){
  
      return diffMinute + " minutes ago"    
  
    }else if(diffHour >= 1 && diffDay < 1){
  
      return diffHour + " hours ago";
      
    }else if(diffDay >= 1 && diffMonths < 1){
  
      return diffDay + " days ago";
  
    }
    else if(diffMonths >= 1 && diffyears < 1){
  
      return diffMonths + " months ago";
      
    }
    else if(diffyears >= 1){
  
      return diffyears + " years ago";
      
    }
    else{
      return new Date(dateStr);
    } 
  }
}
